import axios from 'axios'

class AuthService {
  /**
   * GETs organisation details from the API and saves to localStorage
   * @param {String} orgCode - The organisation code
   */
  populateOrg (orgCode) {
    return axios.get(`${process.env.VUE_APP_API_BASEURL}/org?org_code=${orgCode}`).then(response => {
      if (response.data.identifier) localStorage.setItem('org', JSON.stringify(response.data))

      return response.data
    })
  }

  /**
   * Clears the 'user' object stored in in localStorage
   */
  logout () {
    localStorage.removeItem('user')
  }

  register (user) {
    return axios.post(`${process.env.VUE_APP_API_BASEURL}/user`, {
      username: user.username,
      email: user.email,
      password: user.password
    })
  }

  /**
   * Creates an Authorization header from the JWT access token stored in localStorage
   */
  requestHeader () {
    let user = JSON.parse(localStorage.getItem('user'))
    if (user && user.accessToken) {
      return { Authorization: `Bearer ${user.accessToken}` }
    } else {
      return {}
    }
  }
}

export default new AuthService()
